import { Component } from 'react';
import DatePicker from 'react-datepicker';
import { Redirect } from 'react-router-dom';
import { upsertCommunication, getCommunicationById, loadImageFromUrl } from '../../../modules/communication';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const MAX_CHARACTERS = 100;

export const CommunicationTypes = {
  LOGIN_BANNER: { type: 'LOGIN_BANNER', description: 'Login Banner' },
  WELCOME_POPUP: { type: 'WELCOME_POPUP', description: 'Welcome Popup' },
  DASHBOARD_BANNER: { type: 'DASHBOARD_BANNER', description: 'Dashboard Banner' },
  TOURNAMENT_BANNER: { type: 'TOURNAMENT_BANNER', description: 'Torunament Banner' },
  BADGE: { type: 'BADGE', description: 'Gamification Badge' },
};

class CommunicationEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditMode: false,
      loading: false,

      navigate: '',
      adNameValidMsg: '',
      adDescValidMsg: '',
      startDateValidMsg: '',
      endDateValidMsg: '',
      imageValidMsg: '',

      validationError: null,

      isStartDateReadOnly: false,

      communication: {
        communicationId: null,
        adName: '',
        adDescription: '',
        originalStartDateEdit: Date.now(),
        startDate: Date.now(),
        endDate: Date.now(),
        selectedImage: null,
        imageData: '',
        communicationType: '',
        linkUrl: '',
      },
    };

    this.handleChangedValues = this.handleChangedValues.bind(this);
    this.getCommunicationById = this.getCommunicationById.bind(this);
  }

  async componentDidMount() {
    if (this.props.match.params.communicationId) {
      await this.getCommunicationById(this.props.match.params.communicationId);

      this.setState({
        ...this.state,
        isEditMode: true,
      });
    }
  }

  async getCommunicationById(communicationId) {
    try {
      const communicationResponse = await getCommunicationById(communicationId);
      const theImage = communicationResponse.data.communication[0].image_filename;
      const imageResponse = await loadImageFromUrl(theImage);

      let tmpIsStartDateReadOnly = false;
      const now = Date.now();
      const timestampStartDate = new Date(communicationResponse.data.communication[0].start_time).getTime();
      if (now > timestampStartDate) {
        tmpIsStartDateReadOnly = true;
      }

      this.setState({
        ...this.state,
        isStartDateReadOnly: tmpIsStartDateReadOnly,
        communication: {
          communicationId: this.props.match.params.communicationId,
          adName: communicationResponse.data.communication[0].name,
          adDescription: communicationResponse.data.communication[0].description,
          startDate: new Date(communicationResponse.data.communication[0].start_time).getTime(),
          endDate: new Date(communicationResponse.data.communication[0].end_time).getTime(),
          imageData: imageResponse.imageData,
          selectedImage: null,
          originalStartDateEdit: new Date(communicationResponse.data.communication[0].start_time).getTime(),
          communicationType: communicationResponse.data.communication[0].communication_type,
          linkUrl:
            typeof communicationResponse.data.communication[0].link_url !== 'undefined'
              ? communicationResponse.data.communication[0].link_url
              : '',
        },
      });
    } catch (e) {
      console.error(e);
    }
  }

  handleChangedValues(event) {
    if (event.target) {
      switch (event.target.id) {
        case 'adNameId':
          this.setState({
            ...this.state,
            communication: {
              ...this.state.communication,
              adName: event.target.value,
            },
          });
          break;

        case 'adDescriptionId':
          this.setState({
            ...this.state,
            communication: {
              ...this.state.communication,
              adDescription: event.target.value,
            },
          });
          break;
        case 'adCommunicationType':
          this.setState({
            ...this.state,
            communication: {
              ...this.state.communication,
              communicationType: event.target.value,
            },
          });
          break;
        case 'adLinkUrl':
          this.setState({
            ...this.state,
            communication: {
              ...this.state.communication,
              linkUrl: event.target.value,
            },
          });
          break;
        default:
          break;
      }
    }
  }

  setEndDate(newEndDate) {
    if (!newEndDate) {
      return;
    }

    this.setState({
      ...this.state,
      communication: {
        ...this.state.communication,
        endDate: newEndDate.getTime(),
      },
    });
  }

  setStartDate(newStartDate) {
    if (!newStartDate) {
      return;
    }

    this.setState({
      ...this.state,
      communication: {
        ...this.state.communication,
        startDate: newStartDate.getTime(),
      },
    });
  }

  async setSelectedImage(event) {
    if (event) {
      this.setState({
        ...this.state,
        imageValidMsg: '',
        communication: {
          ...this.state.communication,
          selectedImage: event.target.files[0],
        },
      });
    }
  }

  async removeSelectedImage() {
    this.setState({
      ...this.state,
      imageValidMsg: 'You must select an image',
      communication: {
        ...this.state.communication,
        selectedImage: null,
      },
    });
  }

  async validateAdsData() {
    const { communication, isEditMode, isStartDateReadOnly } = this.state;

    let adNameValidMsg = '';
    if (communication.adName.length === 0 || communication.adName.trim().length === 0) {
      adNameValidMsg = "Ad's name can not be empty";
    } else if (communication.adName.length > MAX_CHARACTERS) {
      adNameValidMsg = `Ad's name can't have more than ${MAX_CHARACTERS} characters`;
    }

    let adDescValidMsg = '';
    if (communication.communicationType !== CommunicationTypes.DASHBOARD_BANNER.type) {
      if (communication.adDescription.length === 0 || communication.adDescription.trim().length === 0) {
        adDescValidMsg = "Ad's description can not be empty";
      } else if (communication.adDescription.length > 3 * MAX_CHARACTERS) {
        adDescValidMsg = `Ad's description can't have more than ${3 * MAX_CHARACTERS} characters`;
      }
    }

    let timestampStartDate = communication.startDate;
    if (typeof timestampStartDate === 'object') {
      timestampStartDate = timestampStartDate.getTime();
    }

    let timestampEndDate = communication.endDate;
    if (typeof timestampEndDate === 'object') {
      timestampEndDate = timestampEndDate.getTime();
    }

    let communicationTypeValidMsg = '';
    if (communication.communicationType === '') {
      communicationTypeValidMsg = 'Type can not be empty';
    }

    let imageValidMsg = '';
    let startDateValidMsg = '',
      endDateValidMsg = '';
    const now = Date.now();
    if (communication.communicationType !== CommunicationTypes.TOURNAMENT_BANNER.type) {
      // update
      if (isEditMode) {
        // if start date is earlier than now ==> the user couldn't edit it
        // if the start date is after now ==> the user can edit it, but can't write it before now still !
        if (now + 1000 >= timestampStartDate && !isStartDateReadOnly) {
          startDateValidMsg = 'Start Date must be after current time';
        }
      }

      // create for the first time ==> "save"
      else {
        if (!communication.selectedImage) {
          imageValidMsg = 'You must select an image';
        }

        if (now + 1000 >= timestampStartDate) {
          startDateValidMsg = 'Start Date must be after current time';
        }
      }

      if (timestampStartDate >= timestampEndDate) {
        endDateValidMsg = 'Ends Date must be after Start Date';
      }
    }

    if (
      !adNameValidMsg &&
      !adDescValidMsg &&
      !imageValidMsg &&
      !startDateValidMsg &&
      !endDateValidMsg &&
      !communicationTypeValidMsg
    ) {
      this.setState({
        ...this.state,
        adNameValidMsg: '',
        adDescValidMsg: '',
        startDateValidMsg: '',
        endDateValidMsg: '',
        imageValidMsg: '',
        validationError: '',
        communicationTypeValidMsg: '',
        loading: true,
        communication: {
          ...this.state.communication,
        },
      });
      return true;
    } else {
      this.setState({
        ...this.state,
        adNameValidMsg,
        adDescValidMsg,
        startDateValidMsg,
        endDateValidMsg,
        imageValidMsg,
        communicationTypeValidMsg,
        validationError: '',
        loading: false,
        communication: {
          ...this.state.communication,
          startDate: timestampStartDate,
          endDate: timestampEndDate,
        },
      });
      return false;
    }
  }

  readFileAsync(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  async validateAdsSubmission() {
    const { isEditMode } = this.state;
    const _communication = { ...this.state.communication };

    this.setState({
      ...this.state,
      loading: true,
    });

    const isDataValid = await this.validateAdsData();

    if (isDataValid) {
      try {
        if (!isEditMode || (isEditMode && _communication.selectedImage)) {
          _communication.imageName = _communication.selectedImage.name;
          const arrayBuffer = await this.readFileAsync(_communication.selectedImage);
          _communication.selectedImage = arrayBuffer.split(',')[1];
        }

        await upsertCommunication(_communication);

        if (isEditMode) {
          toast.success(`the ${_communication.adName} communication was updated successfully.`, {
            position: toast.POSITION.TOP_CENTER,
          });
        } else {
          toast.success(`the ${_communication.adName} communication was uploaded successfully.`, {
            position: toast.POSITION.TOP_CENTER,
          });
        }

        return true;
      } catch (e) {
        if (e.response && e.response.status && e.response.status !== 200) {
          console.error(e.response);

          if (e.response.data) {
            const validationError = { ...e.response.data };
            delete validationError['new_auth'];
            this.setState({
              ...this.state,
              validationError,
              loading: false,
            });
          }
        } else {
          const validationError = {
            description: 'Something went wrong',
          };

          this.setState({
            ...this.state,
            validationError,
            loading: false,
          });
        }
        return false;
      }
    }
    return false;
  }

  async submitAdsData(e) {
    e.preventDefault();
    if (await this.validateAdsSubmission()) {
      this.setState({ ...this.state, navigate: '/communication' });
    }
  }

  render() {
    const {
      navigate,
      adNameValidMsg,
      adDescValidMsg,
      startDateValidMsg,
      endDateValidMsg,
      imageValidMsg,
      validationError,
      communicationTypeValidMsg,
      communication,
      loading,
      isEditMode,
      isStartDateReadOnly,
    } = this.state;

    if (navigate !== '') {
      return <Redirect to={navigate} />;
    }

    return (
      <div className="tw-mx-10 tw-my-5 tw-container tw-text-left">
        <h1 className="tw-font-extrabold tw-text-3xl">Add New Communication</h1>
        <form className="tw-w-full tw-max-w-2xl tw-mt-5" onSubmit={(e) => this.submitAdsData(e)}>
          <div className="tw-flex tw-flex-wrap tw--mx-3 tw-mb-3">
            <div className="tw-w-full md:tw-w-1/2 tw-px-3 tw-mb-6 md:tw-mb-0">
              <label className="tw-form-label" htmlFor="grid-ad">
                Communication Title
              </label>
              <input
                id="adNameId"
                className={
                  adNameValidMsg ? 'tw-form-input-invalid tw-form-input' : 'tw-form-input-default tw-form-input'
                }
                value={communication.adName}
                onChange={this.handleChangedValues}
              />
              {adNameValidMsg && <p className="tw-text-red-500 tw-text-s tw-italic">{adNameValidMsg}</p>}
            </div>
            <div className="tw-w-full md:tw-w-1/2 tw-px-3 tw-mb-6 md:tw-mb-0">
              <label className="tw-form-label" htmlFor="grid-ad">
                Communication Type
              </label>
              <div className={'tw-relative'}>
                <select
                  className={
                    communicationTypeValidMsg
                      ? 'tw-form-input-invalid tw-form-input'
                      : 'tw-form-input-default tw-form-input'
                  }
                  id="adCommunicationType"
                  value={communication.communicationType}
                  onChange={this.handleChangedValues}
                >
                  <option value="" disabled>
                    Select Communication Type
                  </option>
                  {Object.entries(CommunicationTypes).map((commType, index) => {
                    const { type, description } = commType[1];

                    return (
                      <option key={index} value={type}>
                        {description}
                      </option>
                    );
                  })}
                </select>
                <FontAwesomeIcon icon={faChevronDown} className="tw-w-5 tw-h-5 tw-absolute tw-top-3 tw-right-3" />
              </div>
              {communicationTypeValidMsg && (
                <p className="tw-text-red-500 tw-text-s tw-italic">{communicationTypeValidMsg}</p>
              )}
            </div>
          </div>
          <div className="tw-form-row">
            <div className="tw-w-full tw-px-3">
              <label className="tw-form-label" htmlFor="grid-ad">
                Communication Description
              </label>
              <input
                id="adDescriptionId"
                className={
                  adDescValidMsg ? 'tw-form-input-invalid tw-form-input' : 'tw-form-input-default tw-form-input'
                }
                value={communication.adDescription}
                onChange={this.handleChangedValues}
              />
              {adDescValidMsg && <p className="tw-text-red-500 tw-text-s tw-italic">{adDescValidMsg}</p>}
            </div>
          </div>
          {(communication.communicationType === CommunicationTypes.WELCOME_POPUP.type ||
            communication.communicationType === CommunicationTypes.DASHBOARD_BANNER.type) && (
            <div className="tw-form-row">
              <div className="tw-w-full tw-px-3">
                <label className="tw-form-label" htmlFor="grid-ad">
                  Destination URL
                </label>
                <input
                  id="adLinkUrl"
                  className={
                    adDescValidMsg ? 'tw-form-input-invalid tw-form-input' : 'tw-form-input-default tw-form-input'
                  }
                  value={communication.linkUrl}
                  onChange={this.handleChangedValues}
                />
                {adDescValidMsg && <p className="tw-text-red-500 tw-text-s tw-italic">{adDescValidMsg}</p>}
              </div>
            </div>
          )}
          {communication.communicationType !== CommunicationTypes.TOURNAMENT_BANNER.type && (
            <div className="tw-flex tw-flex-wrap tw--mx-3 tw-mb-3">
              <div className="tw-w-full md:tw-w-1/2 tw-px-3 tw-mb-6 md:tw-mb-0">
                <label className="tw-form-label" htmlFor="grid-removal-time">
                  Start Date
                </label>
                <DatePicker
                  id="startDateId"
                  className={
                    startDateValidMsg
                      ? 'tw-form-input-invalid tw-form-input tw-block'
                      : 'tw-form-input-default tw-form-input tw-block'
                  }
                  showTimeSelect
                  dateFormat="Pp"
                  readOnly={isStartDateReadOnly}
                  selected={new Date(communication.startDate)}
                  onChange={(date) => this.setStartDate(date)}
                ></DatePicker>
                {startDateValidMsg && <p className="tw-text-red-500 tw-text-s tw-italic">{startDateValidMsg}</p>}
              </div>
              <div className="tw-w-full md:tw-w-1/2 tw-px-3 tw-mb-6 md:tw-mb-0">
                <label className="tw-form-label" htmlFor="grid-removal-time">
                  End Date
                </label>
                <DatePicker
                  className={
                    endDateValidMsg
                      ? 'tw-form-input-invalid tw-form-input tw-block'
                      : 'tw-form-input-default tw-form-input tw-block'
                  }
                  showTimeSelect
                  dateFormat="Pp"
                  selected={new Date(communication.endDate)}
                  onChange={(date) => this.setEndDate(date)}
                ></DatePicker>
                {endDateValidMsg && <p className="tw-text-red-500 tw-text-s tw-italic">{endDateValidMsg}</p>}
              </div>
            </div>
          )}
          <div className="tw-form-row tw-px-3">
            <div className="tw-w-full tw-py-3">
              {isEditMode && (
                <div>
                  <label className="tw-form-label" htmlFor="grid-ad">
                    Current Communication image
                  </label>
                  <img className="tw-h-32 tw-w-32" alt="not fount" src={communication.imageData} />
                </div>
              )}
              <label className="tw-form-label tw-pt-4" htmlFor="grid-ad">
                Communication image to upload
              </label>
              {communication.selectedImage && (
                <div>
                  <img alt="not fount" src={URL.createObjectURL(communication.selectedImage)} />
                  <button className="tw-btn tw-btn-secondary tw-mt-3" onClick={() => this.removeSelectedImage()}>
                    Remove
                  </button>
                </div>
              )}
              {!communication.selectedImage && (
                <input type="file" name="myImage" onChange={(event) => this.setSelectedImage(event)} />
              )}
              {imageValidMsg && <p className="tw-text-red-500 tw-text-s tw-italic">{imageValidMsg}</p>}
            </div>
            {validationError && <p className="tw-text-red-500 tw-text-s tw-italic">{validationError.description}</p>}
          </div>
          {loading && (
            <div className="ad-table-loader">
              <span className="loading-title">Loading</span>
              <i className="fa fa-spinner fa-spin"></i>
            </div>
          )}
          <div className="tw-form-row">
            <div className="tw-w-full tw-px-1">
              <button
                className="tw-btn tw-btn-secondary tw-float-right tw-mx-2"
                onClick={() => this.setState({ ...this.state, navigate: '/communication' })}
              >
                Cancel
              </button>
              {isEditMode && <button className="tw-btn tw-btn-primary tw-float-right">Update</button>}
              {!isEditMode && <button className="tw-btn tw-btn-primary tw-float-right">Submit</button>}
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default CommunicationEditor;
